var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessOutput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2812 1.8125H2.71875C2.21827 1.8125 1.8125 2.21784 1.8125 2.71875V8.15625C1.8125 8.65716 2.21827 9.0625 2.71875 9.0625H4.53125V47.125H2.71875C2.21827 47.125 1.8125 47.5303 1.8125 48.0312V51.6562C1.8125 52.1572 2.21827 52.5625 2.71875 52.5625H24.4688V53.4688C24.4688 54.968 25.6883 56.1875 27.1875 56.1875H30.8125C32.3117 56.1875 33.5312 54.968 33.5312 53.4688V52.5625H55.2812C55.7817 52.5625 56.1875 52.1572 56.1875 51.6562V48.0312C56.1875 47.5303 55.7817 47.125 55.2812 47.125H53.4688V9.0625H55.2812C55.7817 9.0625 56.1875 8.65716 56.1875 8.15625V2.71875C56.1875 2.21784 55.7817 1.8125 55.2812 1.8125ZM31.7188 53.4688C31.7188 53.9688 31.3121 54.375 30.8125 54.375H27.1875C26.6879 54.375 26.2812 53.9688 26.2812 53.4688V52.5625H31.7188V53.4688ZM54.375 50.75H3.625V48.9375H5.4375H52.5625H54.375V50.75ZM51.6562 47.125H6.34375V9.0625H51.6562V47.125ZM54.375 7.25H52.5625H5.4375H3.625V3.625H54.375V7.25Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4062 35.3438C44.4062 35.6978 44.479 36.0341 44.6027 36.3446L41.1984 39.3273C40.805 39.1058 40.3578 38.9688 39.875 38.9688C39.3185 38.9688 38.8014 39.138 38.37 39.426L35.2083 37.0549C35.2884 36.7989 35.3438 36.532 35.3438 36.25C35.3438 34.7508 34.1242 33.5312 32.625 33.5312C31.1258 33.5312 29.9062 34.7508 29.9062 36.25C29.9062 36.6041 29.979 36.9404 30.1027 37.2508L26.6984 40.2336C26.305 40.012 25.8578 39.875 25.375 39.875C24.1951 39.875 23.1985 40.6349 22.8232 41.6875H15.4062V43.5H22.8233C23.1986 44.5526 24.1951 45.3125 25.375 45.3125C26.8742 45.3125 28.0938 44.093 28.0938 42.5938C28.0938 42.2397 28.021 41.9033 27.8973 41.5929L31.3016 38.6102C31.695 38.8317 32.1422 38.9688 32.625 38.9688C33.1815 38.9688 33.6986 38.7995 34.13 38.5115L37.2917 40.8826C37.2116 41.1386 37.1562 41.4055 37.1562 41.6875C37.1562 43.1867 38.3758 44.4062 39.875 44.4062C41.3742 44.4062 42.5938 43.1867 42.5938 41.6875C42.5938 41.3334 42.521 40.9971 42.3973 40.6866L45.8016 37.7039C46.195 37.9255 46.6422 38.0625 47.125 38.0625C48.6242 38.0625 49.8438 36.843 49.8438 35.3438C49.8438 33.8445 48.6242 32.625 47.125 32.625C45.6258 32.625 44.4062 33.8445 44.4062 35.3438ZM25.375 43.5C24.8754 43.5 24.4688 43.0938 24.4688 42.5938C24.4688 42.0937 24.8754 41.6875 25.375 41.6875C25.8746 41.6875 26.2812 42.0937 26.2812 42.5938C26.2812 43.0938 25.8746 43.5 25.375 43.5ZM32.625 37.1562C32.1254 37.1562 31.7188 36.75 31.7188 36.25C31.7188 35.75 32.1254 35.3438 32.625 35.3438C33.1246 35.3438 33.5312 35.75 33.5312 36.25C33.5312 36.75 33.1246 37.1562 32.625 37.1562ZM39.875 42.5938C39.3754 42.5938 38.9688 42.1875 38.9688 41.6875C38.9688 41.1875 39.3754 40.7812 39.875 40.7812C40.3746 40.7812 40.7812 41.1875 40.7812 41.6875C40.7812 42.1875 40.3746 42.5938 39.875 42.5938ZM48.0312 35.3438C48.0312 35.8438 47.6246 36.25 47.125 36.25C46.6254 36.25 46.2188 35.8438 46.2188 35.3438C46.2188 34.8437 46.6254 34.4375 47.125 34.4375C47.6246 34.4375 48.0312 34.8437 48.0312 35.3438Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 27.1875C21.623 27.1875 24.4688 24.3413 24.4688 20.8438C24.4688 17.3462 21.623 14.5 18.125 14.5C14.627 14.5 11.7812 17.3462 11.7812 20.8438C11.7812 24.3413 14.627 27.1875 18.125 27.1875ZM19.0312 16.4041C19.6087 16.5218 20.1446 16.7524 20.6198 17.0674L19.0312 18.656V16.4041ZM17.2188 16.4041V20.8438C17.2188 21.2101 17.4396 21.5411 17.7781 21.681C17.8905 21.7279 18.0082 21.75 18.125 21.75C18.3609 21.75 18.5923 21.658 18.7657 21.4845L21.9013 18.3489C22.3762 19.0653 22.6562 19.9218 22.6562 20.8438C22.6562 23.3421 20.6234 25.375 18.125 25.375C15.6266 25.375 13.5938 23.3421 13.5938 20.8438C13.5938 18.6557 15.1531 16.8252 17.2188 16.4041Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 30.8125C23.6218 30.8125 28.0938 26.3405 28.0938 20.8438C28.0938 15.347 23.6218 10.875 18.125 10.875V12.6875C22.6222 12.6875 26.2812 16.3461 26.2812 20.8438C26.2812 25.3414 22.6222 29 18.125 29C13.6278 29 9.96875 25.3414 9.96875 20.8438H8.15625C8.15625 26.3405 12.6282 30.8125 18.125 30.8125Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3438 29H38.9688H42.5938H46.2188H48.9375V27.1875H47.125V12.6875C47.125 12.1866 46.7192 11.7812 46.2188 11.7812H42.5938C42.0933 11.7812 41.6875 12.1866 41.6875 12.6875V19.0312H39.875V17.2188C39.875 16.7178 39.4692 16.3125 38.9688 16.3125H35.3438C34.8433 16.3125 34.4375 16.7178 34.4375 17.2188V21.75H31.7188C31.2183 21.75 30.8125 22.1553 30.8125 22.6562V27.1875H29V29H31.7188H35.3438ZM43.5 13.5938H45.3125V27.1875H43.5V19.9375V13.5938ZM41.6875 20.8438V27.1875H39.875V20.8438H41.6875ZM36.25 18.125H38.0625V19.9375V27.1875H36.25V22.6562V18.125ZM32.625 23.5625H34.4375V27.1875H32.625V23.5625Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7812 41.6875H13.5938V43.5H11.7812V41.6875Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15625 41.6875H9.96875V43.5H8.15625V41.6875Z",
    fill: "url(#paint6_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.9018,
    y1: 56.1875,
    x2: 28.9018,
    y2: 1.8125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 32.5628,
    y1: 45.3125,
    x2: 32.5628,
    y2: 32.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 18.1021,
    y1: 27.1875,
    x2: 18.1021,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 18.089,
    y1: 30.8125,
    x2: 18.089,
    y2: 10.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 38.9328,
    y1: 29,
    x2: 38.9328,
    y2: 11.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 12.6842,
    y1: 43.5,
    x2: 12.6842,
    y2: 41.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 9.05923,
    y1: 43.5,
    x2: 9.05923,
    y2: 41.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0162E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885265,
    stopColor: "#DA3535"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessOutput);
export default __webpack_public_path__ + "static/media/process--output.e110f427e5f80ee41675e8daeba01da8.svg";
export { ForwardRef as ReactComponent };